import type Immutable from 'immutable'
import moment from 'moment'

export function isOrderBeingDeliveredToday(deliveryDate: string) {
  const now = moment()
  const orderDeliveryDate = moment(deliveryDate)

  return now.format('YYMMDD') === orderDeliveryDate.format('YYMMDD')
}

export function findNewestOrder(
  orders: Immutable.List<Immutable.Map<string, string>>,
  areFutureOrdersIncluded: boolean,
) {
  const now = moment()

  const orderIndex = orders.reduce((currentOrderIndex, order, index): number | null => {
    const orderDeliveryDate = moment(order?.get('deliveryDate')).endOf('day')
    const orderValidComparedToNow = areFutureOrdersIncluded
      ? orderDeliveryDate.isAfter(now)
      : orderDeliveryDate.isBefore(now)

    if (!orderValidComparedToNow) return currentOrderIndex || null
    if (currentOrderIndex === null) return index || null

    const currentOrderDeliveryDate = moment(
      orders.getIn([currentOrderIndex, 'deliveryDate']),
    ).endOf('day')

    return orderDeliveryDate.isBetween(currentOrderDeliveryDate, now) ||
      orderDeliveryDate.isBetween(now, currentOrderDeliveryDate)
      ? index || null
      : currentOrderIndex || null
  }, null as number | null)

  if (orderIndex === null) {
    return null
  }

  return orders.get(orderIndex) || null
}

export function isValidPromoCode(prices?: { promoCodeValid: boolean }): boolean {
  return prices?.promoCodeValid || false
}

export const getPreviewOrderErrorName = (
  error?: unknown,
): 'no-stock' | 'basket-expired' | 'undefined-error' => {
  if (error && (error as any).code) {
    switch ((error as any).code) {
      case 'out-of-stock':
        return 'no-stock'
      case 'basket-expired':
        return 'basket-expired'
      default:
        return 'undefined-error'
    }
  }

  return 'undefined-error'
}
